import AnimatedSvg, { anim, DELAY, FILL_BOX, resolveTrigger } from "./AnimatedSvg";

/**
 * Menü ikon seti (#233) — varsayılan tetik "hover": ikon, `group` sınıflı
 * menü bağlantısının üzerine gelinince oynar. Her hareket öğenin anlamını
 * anlatır (onay çizilir, pencere yanar, ok yükselir, para düşer...).
 *
 * Ortak props: { className, trigger = "hover" | "always" | "off", animated, title }
 */
const navTrigger = (trigger, animated) => resolveTrigger(trigger, animated, "hover");

/** Dashboard — dört kutucuk sırayla zıplar */
export function DashboardGridIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  const tile = "origin-center";
  return (
    <AnimatedSvg className={className} title={title}>
      <rect x="3.5" y="3.5" width="7" height="7" rx="1.8" className={`${tile} ${anim(t, "iconPop")}`} style={FILL_BOX} />
      <rect x="13.5" y="3.5" width="7" height="7" rx="1.8" className={`${tile} ${anim(t, "iconPop", DELAY.d1)}`} style={FILL_BOX} />
      <rect x="3.5" y="13.5" width="7" height="7" rx="1.8" className={`${tile} ${anim(t, "iconPop", DELAY.d2)}`} style={FILL_BOX} />
      <rect x="13.5" y="13.5" width="7" height="7" rx="1.8" className={`${tile} ${anim(t, "iconPop", DELAY.d3)}`} style={FILL_BOX} />
    </AnimatedSvg>
  );
}

/** İş Planlama — onay işaretleri sırayla çizilir */
export function TasksIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <path d="M4 6.2l1.6 1.6L8.5 5" strokeDasharray="40" className={anim(t, "iconDraw")} />
      <path d="M11.5 6.5h8.5" />
      <path d="M4 12.2l1.6 1.6L8.5 11" strokeDasharray="40" className={anim(t, "iconDraw", DELAY.d1)} />
      <path d="M11.5 12.5h8.5" />
      <path d="M4 18.2l1.6 1.6L8.5 17" strokeDasharray="40" className={anim(t, "iconDraw", DELAY.d2)} />
      <path d="M11.5 18.5h8.5" />
    </AnimatedSvg>
  );
}

/** GitHub — dal çizgisi çizilir, uç düğüm zıplar */
export function GitBranchIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <circle cx="6" cy="5" r="2" />
      <circle cx="6" cy="19" r="2" />
      <path d="M6 7v10" />
      <path d="M18 9c0 5.5-6.5 4.5-11.2 8.3" strokeDasharray="40" className={anim(t, "iconDraw")} />
      <circle cx="18" cy="7" r="2" className={`origin-center ${anim(t, "iconPop")}`} style={FILL_BOX} />
    </AnimatedSvg>
  );
}

/** Cihazlar — ekran satırları yanıp söner */
export function DeviceScreenIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <rect x="3.5" y="3.5" width="17" height="12.5" rx="2" />
      <path d="M9 20.5h6M12 16v4.5" />
      <path d="M7.5 8h9" className={anim(t, "iconBlink")} />
      <path d="M7.5 11.5h5.5" className={anim(t, "iconBlink", DELAY.d1)} />
    </AnimatedSvg>
  );
}

/** Firmalar — bina; pencereler sırayla yanar */
export function BuildingIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <path d="M4.5 21V4.8a1 1 0 0 1 1-1h8.5a1 1 0 0 1 1 1V21" />
      <path d="M15 9.5h3.5a1 1 0 0 1 1 1V21" />
      <path d="M2.5 21h19" />
      <path d="M8 8h3.5" className={anim(t, "iconBlink")} />
      <path d="M8 12h3.5" className={anim(t, "iconBlink", DELAY.d1)} />
      <path d="M8 16h3.5" className={anim(t, "iconBlink", DELAY.d2)} />
      <path d="M17.2 13.5h.01M17.2 17h.01" strokeWidth={2.4} className={anim(t, "iconBlink", DELAY.d3)} />
    </AnimatedSvg>
  );
}

/** Müşterilerim — kravatlı kişi; baş hafifçe sekiyor */
export function CustomerIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <g className={anim(t, "iconBounce")}>
        <circle cx="12" cy="7.5" r="3.6" />
      </g>
      <path d="M4.8 20.5a7.2 7.2 0 0 1 14.4 0" />
      <path d="M12 14.2l-1.1 2.6 1.1 2.4 1.1-2.4-1.1-2.6Z" />
    </AnimatedSvg>
  );
}

/** Bayilerim — dükkân; tente sallanır */
export function StoreIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <path d="M4.5 11.5V20.5h15v-9" />
      <path d="M9.5 20.5v-5h5v5" />
      <g className={`origin-top ${anim(t, "iconWiggle")}`} style={FILL_BOX}>
        <path d="M3 10l2-5.5h14L21 10" />
        <path d="M3 10a2.25 2.25 0 0 0 4.5 0a2.25 2.25 0 0 0 4.5 0a2.25 2.25 0 0 0 4.5 0a2.25 2.25 0 0 0 4.5 0" />
      </g>
    </AnimatedSvg>
  );
}

/** Kullanıcılar / müşterideki cihazlar — iki kişi sırayla seker */
export function UsersIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <g className={anim(t, "iconBounce")}>
        <circle cx="9" cy="8" r="3.2" />
        <path d="M3 20a6 6 0 0 1 12 0" />
      </g>
      <g className={anim(t, "iconBounce", DELAY.d1)}>
        <circle cx="17" cy="9" r="2.6" />
        <path d="M16.2 14.1A5 5 0 0 1 21.5 19.5" />
      </g>
    </AnimatedSvg>
  );
}

/** Satış — yükselen grafik çizilir */
export function SalesChartIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <path d="M3.5 3.5v17h17" />
      <path d="M7 15.5l3.5-3.5 3 2.5 5.5-6.5" strokeDasharray="40" className={anim(t, "iconDraw")} />
      <path d="M15.5 8H19v3.5" />
    </AnimatedSvg>
  );
}

/** Fatura Yükle — belgeye yükleme oku yükselir */
export function InvoiceUploadIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8Z" />
      <path d="M14 3v5h5" />
      <g className={anim(t, "iconRise")}>
        <path d="M12 18v-6.5M9.5 14 12 11.5 14.5 14" />
      </g>
    </AnimatedSvg>
  );
}

/** Teklif Oluştur — tokalaşma sallanır */
export function HandshakeIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <g className={`origin-center ${anim(t, "iconWiggle")}`} style={FILL_BOX}>
        <path d="m11 17 2 2a1 1 0 1 0 3-3" />
        <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.9-3.9a3 3 0 0 0-4.2 0l-.9.9a1 1 0 1 1-3-3l2.8-2.8a5.8 5.8 0 0 1 7.1-.9l.5.3a2 2 0 0 0 1.4.3L21 4" />
        <path d="m21 3 1 11h-2" />
        <path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3" />
        <path d="M3 4h8" />
      </g>
    </AnimatedSvg>
  );
}

/** Ödemeler — cüzdana para düşer */
export function WalletIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <path d="M4 8h14a2 2 0 0 1 2 2v8.5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2.5 2.5 0 0 1 2.5-2.5H8" />
      <path d="M16.5 14.2h.01" strokeWidth={2.6} />
      <circle cx="13" cy="4" r="2" className={anim(t, "iconDrop")} />
    </AnimatedSvg>
  );
}

/** Bildirim Gönder — kâğıt uçak uçar */
export function SendIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <g className={anim(t, "iconFly")}>
        <path d="M21 3 3 10.5l7 2.5 2.5 7L21 3Z" />
        <path d="m10 13 5-5" />
      </g>
    </AnimatedSvg>
  );
}

/** Raporlar — belgenin üstünde büyüteç dolaşır */
export function ReportSearchIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <path d="M13 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4" />
      <path d="M8 8h6M8 12h3" />
      <g className={anim(t, "iconOrbit")}>
        <circle cx="16" cy="15" r="3.5" />
        <path d="m18.6 17.6 2.4 2.4" />
      </g>
    </AnimatedSvg>
  );
}

/** Fabrika genel bakış — bacadan duman yükselir */
export function FactoryIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <path d="M3 20.5V11l5 3.2V11l5 3.2V11l5 3.2V5h3v15.5Z" />
      <path d="M7 17.5h2M12 17.5h2" />
      <path d="M19.5 3.3c-.7.7.7 1.1 0 1.8" className={anim(t, "iconRise")} />
    </AnimatedSvg>
  );
}

/** Parçalar / depodaki cihazlar — kutu kapağı seker */
export function PartsBoxIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <path d="M4.5 10h15v9.5a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1Z" />
      <g className={anim(t, "iconBounce")}>
        <rect x="3" y="6" width="18" height="4" rx="1" />
      </g>
      <path d="M10 13.5h4" />
    </AnimatedSvg>
  );
}

/** Makineler — fincandan buhar yükselir */
export function MachineCupIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <path d="M9 3.5c-.8 1 .8 1.5 0 2.5" className={anim(t, "iconRise")} />
      <path d="M13 3.5c-.8 1 .8 1.5 0 2.5" className={anim(t, "iconRise", DELAY.d2)} />
      <path d="M5 9h12v5a5 5 0 0 1-5 5h-2a5 5 0 0 1-5-5V9Z" />
      <path d="M17 10.5h1.5a2.5 2.5 0 0 1 0 5H17" />
      <path d="M4 21h14" />
    </AnimatedSvg>
  );
}

/** Bölgeler / Cihaz Konumları — harita, üstüne iğne düşer */
export function MapPinDropIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <path d="M9 5 3.5 7v13L9 18l6 2 5.5-2V5L15 7 9 5Z" />
      <path d="M9 5v13M15 7v13" />
      <g className={anim(t, "iconDrop")}>
        <path
          d="M15 13.5s-2.6-2.4-2.6-4.3a2.6 2.6 0 0 1 5.2 0c0 1.9-2.6 4.3-2.6 4.3Z"
          className="fill-white"
        />
        <circle cx="15" cy="9.2" r="0.8" className="fill-current" />
      </g>
    </AnimatedSvg>
  );
}

/** Katalog — dokuz kutucuk çapraz dalga halinde zıplar */
export function CatalogGridIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  const cells = [
    [3.5, 3.5, ""], [10, 3.5, DELAY.d1], [16.5, 3.5, DELAY.d2],
    [3.5, 10, DELAY.d1], [10, 10, DELAY.d2], [16.5, 10, DELAY.d3],
    [3.5, 16.5, DELAY.d2], [10, 16.5, DELAY.d3], [16.5, 16.5, DELAY.d3],
  ];
  return (
    <AnimatedSvg className={className} title={title}>
      {cells.map(([x, y, d]) => (
        <rect
          key={`${x}-${y}`}
          x={x}
          y={y}
          width="4"
          height="4"
          rx="1"
          className={`origin-center ${anim(t, "iconPop", d)}`}
          style={FILL_BOX}
        />
      ))}
    </AnimatedSvg>
  );
}

/** Belgeler — satırlar yazılır gibi çizilir */
export function DocumentsIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8Z" />
      <path d="M14 3v5h5" />
      <path d="M8.5 12.5h7" strokeDasharray="40" className={anim(t, "iconDraw")} />
      <path d="M8.5 16h5" strokeDasharray="40" className={anim(t, "iconDraw", DELAY.d1)} />
    </AnimatedSvg>
  );
}

/** Programlama İşlemleri — panoya onay çizilir */
export function ClipboardCheckIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <rect x="5" y="4.5" width="14" height="17" rx="2" />
      <path d="M9 3h6v3H9z" />
      <path d="m9 13.5 2 2 4-4.5" strokeDasharray="40" className={anim(t, "iconDraw")} />
    </AnimatedSvg>
  );
}

/** Onay Bekleyen Cihazlar — kum saati döner */
export function HourglassIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <g className={`origin-center ${anim(t, "iconFlip")}`} style={FILL_BOX}>
        <path d="M7 3h10M7 21h10" />
        <path d="M8 3c0 4 4 5 4 9s-4 5-4 9M16 3c0 4-4 5-4 9s4 5 4 9" />
        <path d="M10 18.5h4" />
      </g>
    </AnimatedSvg>
  );
}

/** EMQX — bulut süzülür, veri noktaları akar */
export function CloudDataIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <g className={anim(t, "iconFloat")}>
        <path d="M7 16.5h10a4 4 0 0 0 .5-8 5.5 5.5 0 0 0-10.6 1.6A3.2 3.2 0 0 0 7 16.5Z" />
      </g>
      <path d="M9 20.5h.01" strokeWidth={2.6} className={anim(t, "iconBlink")} />
      <path d="M12 20.5h.01" strokeWidth={2.6} className={anim(t, "iconBlink", DELAY.d1)} />
      <path d="M15 20.5h.01" strokeWidth={2.6} className={anim(t, "iconBlink", DELAY.d2)} />
    </AnimatedSvg>
  );
}

/** Audit Log — kalkan; içine onay çizilir */
export function ShieldCheckIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <path d="M12 3 4.5 6v5.5c0 4.6 3.2 8.2 7.5 9.5 4.3-1.3 7.5-4.9 7.5-9.5V6Z" />
      <path d="m9 12 2 2 4-4.5" strokeDasharray="40" className={anim(t, "iconDraw")} />
    </AnimatedSvg>
  );
}

/** Ürün Bilgisi — etiket sallanır */
export function ProductTagIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <g className={`origin-top-left ${anim(t, "iconWiggle")}`} style={FILL_BOX}>
        <path d="M3.5 12.2V4.5a1 1 0 0 1 1-1h7.7l8.3 8.3a1.5 1.5 0 0 1 0 2.1l-6.4 6.4a1.5 1.5 0 0 1-2.1 0Z" />
        <circle cx="8" cy="8" r="1.4" />
      </g>
    </AnimatedSvg>
  );
}

/** Ürün Tipi — harf ve yanıp sönen imleç */
export function TypeCursorIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <path d="M4.5 6.5V4.5h11v2M10 4.5v15M8 19.5h4" />
      <path d="M19 9.5v10" className={anim(t, "iconBlink")} />
    </AnimatedSvg>
  );
}

/** Şehir — siluet; pencereler yanar */
export function CityIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <path d="M2.5 21h19" />
      <path d="M4.5 21V10l5-3v14" />
      <path d="M9.5 21V12h4.5v9" />
      <path d="M14 21V5h5.5v16" />
      <path d="M6.8 13h.01M6.8 16.5h.01" strokeWidth={2.4} className={anim(t, "iconBlink")} />
      <path d="M16.7 9h.01M16.7 12.5h.01" strokeWidth={2.4} className={anim(t, "iconBlink", DELAY.d1)} />
      <path d="M16.7 16h.01" strokeWidth={2.4} className={anim(t, "iconBlink", DELAY.d2)} />
    </AnimatedSvg>
  );
}

/** İlçe — konum iğnesi seker, altında dalga yayılır */
export function MapPinIcon({ className, trigger, animated = true, title }) {
  const t = navTrigger(trigger, animated);
  return (
    <AnimatedSvg className={className} title={title}>
      <ellipse
        cx="12"
        cy="20.5"
        rx="4"
        ry="1.2"
        className={`origin-center ${anim(t, "iconPing")}`}
        style={FILL_BOX}
      />
      <g className={anim(t, "iconBounce")}>
        <path d="M12 17.5s-6-5.2-6-9.5a6 6 0 1 1 12 0c0 4.3-6 9.5-6 9.5Z" />
        <circle cx="12" cy="8" r="2" />
      </g>
    </AnimatedSvg>
  );
}
